import * as animation from "./animation";
import * as music from "./music";
import * as account from "./account";
import * as choreo from "./choreo";
let footerVisible = true;
function toggleFooter() {
    footerVisible = !footerVisible;
    const realFooter = document.querySelector("#realFooter");
    if (footerVisible) {
        realFooter.classList.remove("closedTab");
        realFooter.classList.add("openedTab");
    }
    else {
        realFooter.classList.remove("openedTab");
        realFooter.classList.add("closedTab");
    }
    localStorage.setItem("footerVisible", "" + footerVisible);
}
function main() {
    //callback will not run if auth is unreachable (wont give login button!)
    account.requestProfile((profile) => {
        if (profile) {
            document.querySelector("#helloMsg").textContent = "Hello " + profile.username;
            document.querySelector("#profileButtons").style.display = "flex";
        }
        else {
            document.querySelector("#loginButtons > a").href = "/login/?ret=" + encodeURIComponent(window.location.pathname + window.location.search);
            document.querySelector("#loginButtons").style.display = "flex";
        }
    });
    const hideButton = document.querySelector("#hideFooter");
    hideButton.onclick = toggleFooter;
    const profileButton = document.querySelector("#profileButton");
    profileButton.onclick = () => { window.location.href = "profile/"; };
    //set all the control update things
    let things = document.querySelectorAll("#selectSheet input");
    things.forEach(thing => {
        thing.onchange = () => music.updateSheetInstrumentSelection();
    });
    let things2 = document.querySelectorAll("#selectMusic input");
    things2.forEach(thing => {
        thing.onchange = () => music.updateMusicInstrumentSelection();
    });
    document.querySelector("#partSelector").oninput = () => { music.updateMusicInstrumentSelection(); music.updateSheetInstrumentSelection(); };
    const fv = localStorage.getItem("footerVisible");
    if (fv) {
        footerVisible = fv == "true";
    }
    else {
        footerVisible = false;
        localStorage.setItem("footerVisible", "" + footerVisible);
    }
    const realFooter = document.querySelector("#realFooter");
    if (footerVisible) {
        realFooter.style.height = "85%";
    }
    choreo.setMusic(music);
    choreo.setPiecesMovable(false);
    music.initMusicXML(() => {
        choreo.initChoreo(() => { }, () => {
            music.loadMusicXML("data/" + choreo.currentSet.choreoId + "/score.mxl", () => {
                choreo.setTimelineDuration(music.getDuration());
            });
        });
    });
    document.querySelector("#title").onmouseenter = () => {
        animation.startClose();
        setTimeout(() => {
            if (!document.querySelector("#title").matches(":hover")) {
                animation.startOpen();
            }
        }, 3000);
    };
    document.querySelector("#title").onmouseleave = animation.startOpen;
    window.requestAnimationFrame(loop);
}
function loop(timestamp) {
    choreo.update();
    animation.renderAnimation(timestamp);
    window.requestAnimationFrame(loop);
}
main();
